/**
 * Algolia Hooks - Template Generation and Widget Setup
 * Part of Deuxpardeux Algolia custom implementation
 */

// Remove default Algolia styles
document.addEventListener('algolia.hooks.initialize', function () {

	const unsupportedCountries = [
		'AU',
		'BH',
		'CZ',
		'DK',
		'IN',
		'KW',
		'LI',
		'NO',
		'OM',
		'PL',
		'QA',
		'SA',
		'SE',
		'CH',
		'AE',
		'GB',
		'US'
	];

	
	algoliaShopify.hooks.registerHook('beforeInstantSearchFiltersString', function(defaultFilter) {

		console.log('beforeInstantSearchFiltersString defaultFilter', defaultFilter);

		let additionalFilter = '';
		
		if(defaultFilter) {
			additionalFilter = ' AND NOT tags:ghost_product'
		}
		else {
			additionalFilter = 'NOT tags:ghost_product'
		}

		if(
			(Shopify.locale == "fr" && unsupportedCountries.includes(Shopify.country))
			|| (Shopify.country == "CA" && Shopify.locale == "en")
		) {
			additionalFilter = additionalFilter + ' AND NOT tags:do_not_sell_in_canada'		
		}

		return defaultFilter + additionalFilter;
	});

	const algoliaStyleTag = document.querySelector('#algolia-shopify-instantsearch').previousElementSibling;
	if (algoliaStyleTag && algoliaStyleTag.tagName == 'STYLE') {
		algoliaStyleTag.remove();
	}

	console.log('🔍 Algolia Custom Hooks: Initializing...');

	// Filter Type Mapping Configuration
	const FILTER_TYPE_MAP = {
		'default': 'filter-type-checkboxes',
		'options.size': 'filter-type-buttons filter-type-buttons-5col',
		'meta.custom.variant_size_grouping_filter': 'filter-type-buttons filter-type-buttons-5col filter-type-size-sizes',
		// 'meta.productdetails.color': 'filter-type-buttons filter-type-buttons-2col filter-type-color',
		'meta.custom.color_group': 'filter-type-color-swatches',

		'price_range': 'filter-type-buttons filter-type-buttons-2col',
		'meta.custom.genders_filter': 'filter-type-buttons filter-type-buttons-2col',
		'meta.custom.review_ratings': 'filter-type-checkboxes filter-type-rating-stars',
		'meta.custom.rating_group': 'filter-type-checkboxes filter-type-rating-stars',
		'meta.custom.discounts': 'filter-type-buttons filter-type-buttons-2col',
		'meta.custom.discount_percentage': 'filter-type-buttons filter-type-buttons-2col',
		'meta.custom.discount_percentage_usa': 'filter-type-buttons filter-type-buttons-2col',

		'meta.custom.categories_filter': 'filter-type-checkboxes filter-type-checkboxes-1col',
		'meta.custom.subcategories_filter': 'filter-type-checkboxes filter-type-checkboxes-1col',
		'meta.custom.seasons_filter': 'filter-type-checkboxes',
		'meta.custom.themes_filter': 'filter-type-checkboxes filter-type-checkboxes-1col',
		'tags': 'hidden',

		// Add more mappings as needed
	};

	const FACET_TRANSLATION_MAP = {
		'options.size': 'size',
		'meta.custom.variant_size_grouping_filter': 'size_grouping',
		'meta.productdetails.color_code': 'color',
		'meta.productdetails.color': 'color',
		'meta.custom.color_group': 'color',
		'price_range': 'price',
		'price': 'price',
		'inventory_available': 'in_stock',
		'meta.custom.genders_filter': 'genders',
		'meta.custom.review_ratings': 'reviews',
		'meta.custom.rating_group': 'reviews',
		'meta.custom.discounts': 'discounts',
		'meta.custom.discount_percentage': 'discounts',
		'meta.custom.discount_percentage_usa': 'discounts',
		'meta.custom.categories_filter': 'categories',
		'meta.custom.subcategories_filter': 'subcategories',
		'meta.custom.seasons_filter': 'seasons',
		'meta.custom.themes_filter': 'themes',
		'tags': 'tags',
	};

	algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function (_defaultTemplate, hit, html, components, trackSearchAttribution) {
		console.log('HIT', hit);
		// All the HTML generation is now in the helper
		return window.algoliaProductHelpers.createProductCardHTML(hit, {
			html,
			components,
			itemLink: algoliaShopify.helpers.instantsearchLink(hit).split('?')[0],
			trackSearchAttribution,
			algoliaLocales: window.algoliaLocales.badges
		});
	});

	algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function (_defaultTemplate, data, html) {
		console.log('🏗️ Creating custom main template with dynamic data...', data);

		// Check if this is search template
		window.isSearchTemplate = (document.body?.dataset?.template === 'search') || document.body.classList.contains('template-search');
		
		// Get search term from URL
		const urlTerm = new URLSearchParams(window.location.search).get('q') || '';
		const searchTerm = decodeURIComponent(urlTerm).trim();


		// Build search banner HTML for search template only
		const searchBannerHtml = window.isSearchTemplate ? html`
			<div class="collection-banner-content">
				<span class="visually-hidden">Search:</span>
				<h1 data-search-title>${(window.algoliaLocales?.search_results_for || 'Search results for "[term]"').replace('[term]', `" ${searchTerm} "`)}</h1>
				<span class="collection-count search-count" data-search-count></span>
    		</div> 
		` : '';

		return html
			`<div class="ais-page algolia-custom-layout layout-switching">
				<div class="pagination-scroll-anchor"></div>

				${searchBannerHtml}

				<!-- Search Header -->
				<div class="search-header">
					<div class="search-header-top">

						<button type="button" class="ais-facets-button" style="display: none;"></button>

						<!-- Toggle for sidebar -->
						<button type="button" class="filter-sort-toggle">
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
								<line x1="0" y1="6" x2="24" y2="6"></line>
								<line x1="4" y1="12" x2="20" y2="12"></line>
								<line x1="8" y1="18" x2="16" y2="18"></line>
							</svg>
							<span class="filter-sort-toggle-text">
								<span class="show-filters-text filter-sort-toggle-text-item">${window.algoliaLocales.show_filters}</span>
								<span class="hide-filters-text filter-sort-toggle-text-item">${window.algoliaLocales.hide_filters}</span>
							</span>
						</button>

						<!-- Product/Worn Toggle -->
						<div class="product-worn-toggle">
							<label class="toggle-switch">
								<input type="checkbox" id="product-worn-toggle" />
								<span class="toggle-indicator"></span>
								<span class="toggle-label">${window.algoliaLocales.product}</span>
								<span class="toggle-label">${window.algoliaLocales.worn}</span>
							</label>
						</div>
					</div>

					
				</div>
        
				<div class="ais-input" style="display: none;">
					<div class="ais-search-box-container"></div>
					<div class="ais-input-button">
						<div class="ais-clear-input-icon"></div>
					</div>
				</div>

				<div class="search-main">
					<div class="search-sidebar">
						<div class="search-sidebar-inner">
							<div class="search-sidebar-header">
								<div class="search-sidebar-title">
									<span>${window.algoliaLocales.filters_title}</span>
									<div class="search-sidebar-title__results-count"></div>
								</div>
								<button class="close-button search-sidebar-close" aria-label="${window.algoliaLocales.close_title}">
									<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
										<line x1="18" y1="6" x2="6" y2="18"></line>
										<line x1="6" y1="6" x2="18" y2="18"></line>
									</svg>
								</button>
							</div>
							
							<div class="ais-current-refined-values-container" style="display: none;"></div>

							<div class="search-header-bottom search-sidebar-active-filters">
								<ul id="current-refinements-mobile" class="search-header-active-filters"></ul>
								<div class="ais-clear-refinements-container ais-clear-refinements-container-mobile"></div>
							</div>

							<div class="ais-facets search-filters">
								<div class="ais-sort">
									${data.multipleSortOrders ? html`
										<span class="ais-sort-label">${window.algoliaLocales.sort_by}</span>
										<span class="ais-sort-orders-container"></span>
									` : html`
										${window.algoliaLocales.sort_by}
										${window.algoliaLocales.relevance}
									`}
								</div>
								
								${data.facets.map(
								// ${algoliaShopify.facets.map(
									
									facet => {
										// Get filter type class based on facet name
										const filterTypeClass = FILTER_TYPE_MAP[facet.escapedName] || FILTER_TYPE_MAP['default'];

										const translationKey = FACET_TRANSLATION_MAP[facet.escapedName];
										const translatedTitle = window.algoliaLocales?.facets?.[translationKey];
										const facetTitle = translatedTitle || facet.title;

										return html`
											<details 
												open
												class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName} ${filterTypeClass}"
											>
												<summary>${facetTitle}</summary>
												<div class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"></div>
											</details>
										`;
									}
								)}
							</div>
							
							<!-- Show Results Button (Mobile) -->
							<button class="show-results-btn show-results-button search-sidebar-close"></button>
						</div>
          			</div>
          
					<!-- Search Products -->
					<div class="search-products">
						<div class="ais-search-header" style="display: none;">
							<div class="ais-stats-container"></div>
							<div class="ais-change-display">
								<span class="ais-change-display-block ais-change-display-selected">
									<i class="fa fa-th-large"></i>
								</span>
								<span class="ais-change-display-list">
									<i class="fa fa-th-list"></i>
								</span>
							</div>
						</div>

						<div class="ais-hits-container ais-results-as-block"></div>
					<div class="ais-pagination-container"></div>
				</div>
				</div>
			</div>`;
	});

	algoliaShopify.hooks.registerHook('beforeISStartAddWidgetArray', function () {
		// Please be aware not all widgets are available
		const { stats, clearRefinements, pagination } = window.algoliaShopify.externals.widgets;

		const customPagination = pagination({
			container: '.ais-pagination-container',
			scrollTo: document.querySelector('.pagination-scroll-anchor'),
			padding: 1,
			templates: {
				first() {
					return '‹‹';
				},
				previous() {
					return '‹';
				},
				next() {
					return '›';
				},
				last() {
					return '››';
				}
			},
		});

		const resultsCountInButton = stats({
			container: '.show-results-button',
			templates: {
				text(data, { html }) {
					return html`${window.algoliaLocales.show_results.replace('[count]', data.nbHits)}`;
				},
			},
		});

		let searchCount;
		if (window.isSearchTemplate) {
			searchCount = stats({
				container: '.search-count',
				templates: {
					text(data, { html }) {
						return html`(${window.algoliaLocales.search_products.replace('[count]', data.nbHits)})`;
					},
				},
			});
		}

		const resultsCountInTitle = stats({
			container: '.search-sidebar-title__results-count',
			templates: {
				text(data, { html }) {
					return html`${window.algoliaLocales.results_count_html.replace('[count]', data.nbHits)}`;
				},
			},
		});

		const sidebarToggle = {
			init: () => {
				const filterToggle = document.querySelector('.filter-sort-toggle');
				const layout = document.querySelector('.algolia-custom-layout');
				const searchSidebar = document.querySelector('.search-sidebar');
				const closeButtons = document.querySelectorAll('.search-sidebar-close');

				// Restore sidebar state from localStorage
				const savedSidebarState = localStorage.getItem('algolia-sidebar-open') || 'true';
				const shouldOpenSidebar = savedSidebarState === 'true';
				console.log('shouldOpenSidebar', shouldOpenSidebar);

				if (filterToggle && layout) {
					// Apply saved state on initialization
					calculateHeaderHeight();

					if (shouldOpenSidebar && window.innerWidth > 1023) {
						layout.classList.add('sidebar-open');
						searchSidebar.inert = false;
					}

					setTimeout(() => {
						layout.classList.remove('layout-switching');
					}, 300);

					filterToggle.addEventListener('click', (e) => {
						e.preventDefault();

						const isOpen = layout.classList.contains('sidebar-open');
						
						console.log('saving state', !isOpen);
						// Save state to localStorage
						localStorage.setItem('algolia-sidebar-open', !isOpen);
						console.log('localStorage', localStorage.getItem('algolia-sidebar-open'));
						
						// Use the 3-phase animation system
						if (window.threePhaseAnimator) {
							window.threePhaseAnimator.animateSidebarToggle();
						} else {
							// Fallback to simple toggle
							if (!isOpen) {
								layout.classList.add('sidebar-open');
								searchSidebar.inert = false;

								calculateHeaderHeight();
								if (window.innerWidth < 768) {
									document.body.style.overflowY = 'hidden';
								}
							} else {
								layout.classList.remove('sidebar-open');
								searchSidebar.inert = true;
								document.body.style.overflowY = 'auto';
							}
						}
					});
				}

				// Close buttons
				closeButtons.forEach(button => {
					button.addEventListener('click', (e) => {
						e.preventDefault();
						
						const isOpen = layout.classList.contains('sidebar-open');
						if (isOpen) {
							// Save closed state to localStorage
							localStorage.setItem('algolia-sidebar-open', 'false');
							
							// Use the 3-phase animation system for closing
							if (window.threePhaseAnimator) {
								window.threePhaseAnimator.animateSidebarToggle();
							} else {
								// Fallback to simple close
								layout.classList.remove('sidebar-open');
								searchSidebar.inert = true;
								document.body.style.overflowY = 'auto';
							}
						}
					});
				});

				// Initialize grid layout (this one is correct - just sets initial columns)
				window.threePhaseAnimator?.updateGridLayout();
			}
		};

		const clearRefinementsTemplates = {
			resetLabel({ hasRefinements }, { html }) {
				// console.log('clearRefinementsTemplates', ...arguments);

				return html`${hasRefinements ? 'Clear' : null}`;
			}
		};
		// const clearRefinementsDesktop = clearRefinements({
		// 	container: '.ais-clear-refinements-container-desktop',
		// 	templates: clearRefinementsTemplates,
		// });

		const clearRefinementsMobile = clearRefinements({
			container: '.ais-clear-refinements-container-mobile',
			excludedAttributes: ['tags'],
			templates: clearRefinementsTemplates,
		});

		const activeFiltersWrapper = document.querySelector('.search-header-bottom');
		// const activeFiltersContainer = document.querySelector('#current-refinements');
		const activeFiltersContainerMobile = document.querySelector('#current-refinements-mobile');

		const createDataAttribtues = refinement =>
			Object.keys(refinement)
				.map(key => `data-${key}="${refinement[key]}"`)
				.join(' ');

		const renderListItem = (item, algoliaLocales) => {

			console.log('🔍 renderListItem', item);

			return item.refinements.map((refinement) => {
				let label = refinement.label;
				let value = refinement.value;
		

				if (refinement.attribute === 'tags') {
					return `
					`;
				}

				if (refinement.attribute === 'price') {
					label = `${algoliaLocales.price_prefix} ${refinement.operator} ${value} CAD`;
				}

				// Special handling for availability
				if (refinement.attribute === 'inventory_available') {
					if (value === 'true') {
						label = algoliaLocales.in_stock;
					} else if (value === 'false') {
						label = algoliaLocales.out_of_stock;
					}
				}

				// Special handling for size
				if (refinement.attribute === 'options.size' || refinement.attribute === 'meta.custom.variant_size_grouping_filter') {
					label = `${algoliaLocales.size_prefix} ${label}`;
				}

				if (
					refinement.attribute === 'meta.custom.categories_filter' 
					|| refinement.attribute === 'meta.custom.subcategories_filter'
					|| refinement.attribute === 'meta.custom.genders_filter'
					|| refinement.attribute === 'meta.custom.seasons_filter'
				) {
					label = getTranslatedLabel(label, refinement.attribute);
				}
	  
				return `
						<li>
							<button ${createDataAttribtues(refinement)}>
								<span>
								  ${label}
								</span>
								<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
									<line x1="18" y1="6" x2="6" y2="18" stroke-width="2"></line>
									<line x1="6" y1="6" x2="18" y2="18" stroke-width="2"></line>
								</svg>
							</button>
						</li>
					`;
			  }).join('');
		};

		const renderCurrentRefinements = (renderOptions, isFirstRender) => {
			const { items, refine, widgetParams } = renderOptions;

			const filteredItems = items;

			widgetParams.container.innerHTML = `
				${filteredItems.map(item => renderListItem(item, algoliaLocales)).join('')}
			`;

			if (filteredItems.length == 0) {
				activeFiltersWrapper.classList.add('empty');
			} else {
				activeFiltersWrapper.classList.remove('empty');
			}

			[...widgetParams.container.querySelectorAll('button')].forEach(element => {
				element.addEventListener('click', event => {
					const item = Object.keys(event.currentTarget.dataset).reduce(
						(acc, key) => ({
							...acc,
							[key]: event.currentTarget.dataset[key],
						}),
						{}
					);

					refine(item);
				});
			});
		};

		const { connectCurrentRefinements } = window.algoliaShopify.externals.connectors;
		// Create the custom widget
		const customCurrentRefinements = connectCurrentRefinements(
			renderCurrentRefinements
		);

		// Instantiate the custom widget
		// const appliedFilters = customCurrentRefinements({
		// 	container: activeFiltersContainer,
		// });

		const appliedFiltersMobile = customCurrentRefinements({
			container: activeFiltersContainerMobile,
		});
		
		const { refinementList } = window.algoliaShopify.externals.widgets;



	// Create a custom rating group filter using the 'refinementList' widget
	// Only create if container exists on the page to avoid errors
	let ratingGroupFilter = null;
	if (document.querySelector('.ais-facet-meta\\.custom\\.rating_group-container')) {
		ratingGroupFilter = refinementList({
			container: '.ais-facet-meta\\.custom\\.rating_group-container',
			attribute: 'meta.custom.rating_group',
			transformItems: function(items) {
				// Sort items from highest rating to lowest and add " stars" to labels
				return items.sort((a, b) => {
					// Extract first number from range (e.g., "4.5 - 5" -> 4.5, "4 - 4.5" -> 4)
					const getFirstNumber = (label) => {
						const match = label.match(/^(\d+(?:\.\d+)?)/);
						return match ? parseFloat(match[1]) : 0;
					};
					return getFirstNumber(b.label) - getFirstNumber(a.label);
				}).map(item => {
					let ratingValue = 1; // default

					// Map ranges to star ratings for visual display
					if (item.label === '4.5 - 5') {
						ratingValue = 5;
					} else if (item.label === '4 - 4.5') {
						ratingValue = 4.5;
					} else if (item.label === '3 - 4') {
						ratingValue = 4;
					} else if (item.label === '2 - 3') {
						ratingValue = 3;
					} else if (item.label === '1 - 2') {
						ratingValue = 2;
					}

					return {
						...item,
						label: item.label + ' stars',
						ratingValue: ratingValue
					};
				});
			},
			templates: {
				item(item, { html }) {
					return html`
						<a
							href="${item.url}"
							class="ais-RefinementList-link ${item.isRefined ? 'is-active' : ''}"
						>
							<span class="ais-RefinementList-label">
								<span class="ais-RefinementList-stars">
									${renderRatingStars(item.ratingValue, { html })}
								</span>
								<span class="ais-RefinementList-labelText">${item.label.replace('&amp;', '&')}</span>
							</span>
						</a>
					`;
				},
				list(options, { html }) {
					return html`<div class="ais-RefinementList-list--rating">${options.items}</div>`;
				}
			}
		});
	}

		const availabilityLinker = {
			init() {
				// This widget has no UI, it only hooks into the search lifecycle.
			},
			render({ helper }) {
				const sizeAttribute = 'meta.custom.variant_size_grouping_filter';
				const availabilityAttribute = 'inventory_available';
				const availabilityValue = 'true';

				const isSizeRefined = helper.state.isDisjunctiveFacetRefined(sizeAttribute);
				const isAvailabilityRefined = helper.state.isDisjunctiveFacetRefined(availabilityAttribute, availabilityValue);

				// If a size is selected, availability MUST be active.
				if (isSizeRefined && !isAvailabilityRefined) {
					console.log('Size selected, adding availability filter.');
					helper.addDisjunctiveFacetRefinement(availabilityAttribute, availabilityValue).search();
				}
				// If no size is selected, availability MUST NOT be active.
				else if (!isSizeRefined && isAvailabilityRefined) {
					// console.log('No size selected, removing availability filter.');
					// helper.removeDisjunctiveFacetRefinement(availabilityAttribute, availabilityValue).search();
				}
			}
		};

		// --- Custom InstantSearch Widgets ---

		// Global state for category baseline counts
		window.__CATEGORY_BASELINE_SNAPSHOT__ = window.__CATEGORY_BASELINE_SNAPSHOT__ || null;
		window.__BASELINE_CAPTURED__ = window.__BASELINE_CAPTURED__ || false;
		window.__SHOW_BASELINE_COUNTS__ = typeof window.__SHOW_BASELINE_COUNTS__ === 'undefined' ? true : window.__SHOW_BASELINE_COUNTS__;

		// Initialize global state trackers for the category linker widget
		window.__LAST_CATEGORY_REFINEMENTS__ = window.__LAST_CATEGORY_REFINEMENTS__ || [];
		window.__CURRENT_ACTIVE_CATEGORY__ = window.__CURRENT_ACTIVE_CATEGORY__ || null;

		/**
		 * Custom widget to link Categories and Subcategories behavior.
		 * - Enforces single selection for categories.
		 * - Clears subcategory refinements when the active category changes.
		 */
		const categorySubcategoryLinker = {
			init() {},
			render({ results, helper }) {

				// const categories = helper.searchForFacetValues('meta.custom.categories_filter').then(categories => {
				// 	console.log('categorySubcategoryLinker categories', categories);
				// });
				// // console.log('categories', categories);
				// const subcategories = helper.searchForFacetValues('meta.custom.subcategories_filter').then(subcategories => {
				// 	console.log('categorySubcategoryLinker subcategories', subcategories);
				// });
				// console.log('subcategories', subcategories);

				// console.log('categorySubcategoryLinker helper');
				// console.log('categorySubcategoryLinker props', ...arguments);

				const categoriesAttribute = 'meta.custom.categories_filter';
				const subcategoriesAttribute = 'meta.custom.subcategories_filter';
				const currentRefinements = helper.getRefinements(categoriesAttribute);

				// 1. Enforce single category selection
				if (currentRefinements.length > 1) {
					const lastRefinements = window.__LAST_CATEGORY_REFINEMENTS__;
					const newItem = currentRefinements.find(r => !lastRefinements.find(lr => lr.value === r.value));
					const categoryToKeep = newItem || currentRefinements[0]; // Fallback to first

					helper.clearRefinements(categoriesAttribute)
						.addDisjunctiveFacetRefinement(categoriesAttribute, categoryToKeep.value)
						.search();
					return; // A new search is triggered, so we wait for re-render.
				}
				window.__LAST_CATEGORY_REFINEMENTS__ = currentRefinements;

				// 2. Clear subcategories if the active category changes
				const activeCategory = currentRefinements.length === 1 ? currentRefinements[0] : null;
				if (window.__CURRENT_ACTIVE_CATEGORY__?.value !== activeCategory?.value) {
					if (helper.getRefinements(subcategoriesAttribute).length > 0) {
						window.__CURRENT_ACTIVE_CATEGORY__ = activeCategory;
						helper.clearRefinements(subcategoriesAttribute).search();
						return; // A new search is triggered, wait for re-render.
					}
				}
				window.__CURRENT_ACTIVE_CATEGORY__ = activeCategory;

				// 3. Preselect single category if only one is available
				if (currentRefinements.length === 0 && results) {
					console.log('categorySubcategoryLinker category results', results);

					const categoryFacetData = results.getFacetValues(categoriesAttribute, {});
					console.log('categorySubcategoryLinker category facet data', categoryFacetData);

					if (categoryFacetData && categoryFacetData.length === 1) {
						const singleCategory = categoryFacetData[0];

						helper.addDisjunctiveFacetRefinement(categoriesAttribute, singleCategory.escapedValue);
						helper.search();
						return; // Trigger search and wait for re-render
					}
				}

				// // 4. Preselect single subcategory if only one is available after category selection

				// if (currentRefinements.length === 1 && results) {
				// 	const subcategoryFacetData = results.getFacetValues(subcategoriesAttribute, {});
				// 	console.log('categorySubcategoryLinker subcategory facet data', subcategoryFacetData);

				// 	if (subcategoryFacetData && subcategoryFacetData.length === 1) {
				// 		const singleSubcategory = subcategoryFacetData[0];

				// 		// helper.addDisjunctiveFacetRefinement(subcategoriesAttribute, singleSubcategory.escapedValue);
				// 	}
				// }
					
			},
			dispose() {
				// Clean up global state if the widget is ever removed.
				delete window.__LAST_CATEGORY_REFINEMENTS__;
				delete window.__CURRENT_ACTIVE_CATEGORY__;
			}
		};

		/**
		 * Custom widget to handle the initial load edge case for category baselines.
		 * If a user lands on a page with a subcategory already refined, this widget
		 * quickly runs a background search to get the correct baseline for categories.
		 */
		const initialLoadManager = {
			_ran: false,
			init({ helper }) {
				if (this._ran) return;
				this._ran = true;

				const subcategoriesAttribute = 'meta.custom.subcategories_filter';
				const subcatRefinements = helper.getRefinements(subcategoriesAttribute);

				if (subcatRefinements.length > 0) {
					// 1. Temporarily clear subcategories
					helper.clearRefinements(subcategoriesAttribute);

					// 2. Run a search and listen for the result once
					helper.once('result', (event) => {
						const categoryFacetData = event.results.getFacetValues('meta.custom.categories_filter', {});
						window.__CATEGORY_BASELINE_SNAPSHOT__ = categoryFacetData.data.map(item => ({ ...item, isRefined: false }));
						window.__BASELINE_CAPTURED__ = true;

						// 3. Re-apply the original subcategory filters and trigger the final search
						subcatRefinements.forEach(ref => {
							helper.addDisjunctiveFacetRefinement(subcategoriesAttribute, ref.value);
						});
						helper.search();
					});

					helper.search(); // Trigger the intermediate search
				}
			}
		};

		const { configure } = window.algoliaShopify.externals.widgets;
		
		const configureFacetingAfterDistinct = configure({
			facetingAfterDistinct: false
		});
		

	// --- End Custom Widgets ---

	let results = [resultsCountInButton, resultsCountInTitle, sidebarToggle,
		 appliedFiltersMobile,
		 clearRefinementsMobile, customPagination,
		availabilityLinker,
		// ratingFilter,
		categorySubcategoryLinker,
		initialLoadManager,
		configureFacetingAfterDistinct
	];

	// Add ratingGroupFilter only if it was created (container existed)
	if (ratingGroupFilter) {
		results.push(ratingGroupFilter);
	}

		if (window.isSearchTemplate) {
			results = [...results, searchCount];
		}

		return results;
	});

	algoliaShopify.hooks.registerHook('afterISStartRemoveDefaultWidget', function (defaultWidgets) {
		// Find and return the default pagination widget
		const defaultStats = defaultWidgets.find(
			widget => widget.$$widgetType === "ais.stats"
		);

		return [defaultStats];
	});

	/**
	 * Renders a set of stars for a given rating.
	 * @param {number} rating - The rating value (e.g., 4, 5).
	 * @param {object} html - The html helper from Algolia.
	 * @returns {string} - The HTML string for the stars.
	 */
	function renderRatingStars(rating, { html }) {
		return html`
			<div class="product-card__stars">
				${Array.from({ length: 5 }, (_, i) => {
					const isFullStar = i < Math.floor(rating);
					const isPartialStar = !isFullStar && i < Math.ceil(rating);
					const partialFill = isPartialStar ? (rating - Math.floor(rating)) * 100 : 0;

					return html`
						<div class="product-card__star-wrapper ${isFullStar ? 'product-card__star--active' : ''} ${isPartialStar ? 'product-card__star--partial' : ''}">
							<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg" class="product-card__star">
								<path d="M9.44071 15.4206C9.16931 15.2561 8.829 15.2561 8.55761 15.4206L4.39532 17.9434C3.75017 18.3344 2.95263 17.7559 3.12406 17.0212L4.22755 12.2922C4.29924 11.985 4.19529 11.6633 3.95739 11.4561L0.293637 8.26557C-0.273874 7.77136 0.031211 6.83787 0.781053 6.77419L5.60934 6.36418C5.92375 6.33748 6.19766 6.13919 6.3212 5.84883L8.21605 1.39536C8.51015 0.704152 9.48985 0.704153 9.78395 1.39536L11.6788 5.84883C11.8023 6.13919 12.0762 6.33748 12.3907 6.36418L17.2189 6.77419C17.9688 6.83787 18.2739 7.77136 17.7064 8.26557L14.0426 11.4561C13.8047 11.6633 13.7008 11.985 13.7725 12.2922L14.876 17.0216C15.0474 17.7562 14.25 18.3347 13.6048 17.9438L9.44071 15.4206Z" fill="currentColor"/>
							</svg>
							${isPartialStar ? html`
								<div class="product-card__star-fill" style="width: ${partialFill}%"></div>
							` : ''}
						</div>
					`;
				})}
			</div>
		`;
	}

	// Helper function to convert English label to handlized key for translation lookup
	const handleizeLabel = (label) => {
		return label
			.toLowerCase()
			.replace(/&/g, '')
			.replace(/-/g, ' ')
			.replace(/\s+/g, '_')
			.replace(/_+/g, '_')
			.replace(/^_|_$/g, '');
	};

	// Helper function to decode HTML entities
	const decodeHtmlEntities = (str) => {
		const textarea = document.createElement('textarea');
		textarea.innerHTML = str;
		return textarea.value;
	};

	// Helper function to get translated label
	const getTranslatedLabel = (label, type) => {
		console.log('getTranslatedLabel', label, type);
		const translations = window.algoliaFilterTranslations;
		if (!translations || !translations[type]) return label;
		
		const key = handleizeLabel(label);
		const translated = translations[type][key] || label;
		return decodeHtmlEntities(translated);
	};

	algoliaShopify.hooks.registerHook('beforeInstantSearchFacetParamsOptions', function (params, facet) {
		const sizeFacetNames = ['options.size', 'meta.custom.variant_size_grouping_filter'];


		// Customize the Categories filter to use baseline counts
		if (facet.escapedName === 'meta.custom.categories_filter') {
			return {
				...params,
				limit: 1000,
				showMore: false,
				sortBy: ['name:asc'],
				templates: {
					item(item, { html }) {
					  const { url, label, count, isRefined } = item;
					  const translatedLabel = getTranslatedLabel(label, facet.escapedName);
				
					  return html`
						<label class="ais-RefinementList-label category-facet-label ais-facet--label">
							<input type="checkbox" class="ais-RefinementList-checkbox ais-facet--checkbox ${isRefined ? 'checked' : ''}" ${isRefined ? 'checked' : ''} />
							<span class="ais-RefinementList-custom-label">${translatedLabel}</span>
							<span class="ais-RefinementList-count ais-facet--count-distinct">${count}</span>
						</label>
					  `;
					},
				},
				transformItems: function(items, { results }) {
					const categoriesAttribute = 'meta.custom.categories_filter';
					const subcategoriesAttribute = 'meta.custom.subcategories_filter';

					const state = results._state;
					const isSubcategoryRefined = state.disjunctiveFacetsRefinements[subcategoriesAttribute]?.length > 0;

					// If no subcategory is refined, the live items are correct.
					// This is the moment to update our cache.
					if (!isSubcategoryRefined) {
						window.__CATEGORY_BASELINE_SNAPSHOT__ = items.map(item => ({ ...item }));
						window.__BASELINE_CAPTURED__ = true;
						return items; // Return live, sorted items
					}

					// If a subcategory IS refined, we use the cached baseline to ensure all categories are shown.
					if (window.__BASELINE_CAPTURED__) {
						const masterList = window.__CATEGORY_BASELINE_SNAPSHOT__;
						const liveRefinedValue = items.find(i => i.isRefined)?.value;

						const transformedItems = masterList.map(baselineItem => {
							const isRefined = baselineItem.value === liveRefinedValue;
							const hideCountClass = !window.__SHOW_BASELINE_COUNTS__ ? 'ais-RefinementList-count--hidden' : '';

							return {
								...baselineItem,
								isRefined: isRefined,
								count: baselineItem.count, // Use the baseline count
								cssClasses: {
									...baselineItem.cssClasses,
									count: [baselineItem.cssClasses?.count, hideCountClass].filter(Boolean).join(' ')
								}
							};
						});

						return transformedItems;
					}

					// Fallback: return original items if no baseline is available yet.
					return items;
				}
			};
		}

		// Show all subcategories and hide "show more"
		if (facet.escapedName === 'meta.custom.subcategories_filter') {
			return {
				...params,
				limit: 1000,
				showMore: false,
				sortBy: ['name:asc'],
				templates: {
					item(item, { html }) {
					  const { url, label, count, isRefined } = item;
					  const translatedLabel = getTranslatedLabel(label, facet.escapedName);
				
					  return html`
						<label class="ais-RefinementList-label ais-facet--label">
							<input type="checkbox" data-subcategory-facet-label="${label}" class="ais-RefinementList-checkbox ais-facet--checkbox ${isRefined ? 'checked' : ''}" ${isRefined ? 'checked' : ''} />
							<span class="ais-RefinementList-custom-label">${translatedLabel}</span>
							<span class="ais-RefinementList-count ais-facet--count-distinct">${count}</span>
						</label>
					  `;
					},
				}
			};
		}
	
		// sort discount percentages and rating groups
		if (facet.escapedName === 'meta.custom.discount_percentage' || facet.escapedName === 'meta.custom.discount_percentage_usa') {
			return {
				...params,
				limit: 1000,
				showMore: false,
				sortBy: ['name:asc']
			};
		}
		if (facet.escapedName === 'meta.custom.rating_group') {
			return {
				...params,
				limit: 1000,
				showMore: false,
				sortBy: ['name:desc']
			};
		}
	
		// Customize the Size filter
		if (sizeFacetNames.includes(facet.escapedName)) {
			return {
				...params,
				limit: 100, // Show all sizes
				showMore: false, // Disable the "Show more" button
				transformItems: function(items) {
					const months = [];
					const numbers = [];
	
					// Separate items into month-based and numeric sizes
					items.forEach(item => {
						if (item.label.toLowerCase().endsWith('m')) {
							months.push(item);
						} else {
							numbers.push(item);
						}
					});
	
					// Sort month-based sizes numerically
					months.sort((a, b) => {
						const numA = parseInt(a.label.replace(/m/i, ''), 10);
						const numB = parseInt(b.label.replace(/m/i, ''), 10);
						return numA - numB;
					});
	
					// Sort numeric sizes numerically
					numbers.sort((a, b) => {
						const numA = parseInt(a.label, 10);
						const numB = parseInt(b.label, 10);
						return numA - numB;
					});
	
					// Combine the sorted lists
					return [...months, ...numbers];
				}
			};
		}
		
		// Customize the Availability filter
		if (facet.escapedName === 'inventory_available') {
			return {
				...params,
				sortBy: ['name:desc'],
				templates: {
					item(item, { html }) {
					  	const { url, label, count, isRefined } = item;

						// debugger;

						// Only render if this is the 'In Stock' option
						if (item.value === 'true') {
							return html`
								<div class="inventory-toggle-wrapper">
									<label class="toggle-switch">
										<input type="checkbox" class="ais-RefinementList-checkbox inventory-toggle-checkbox ${isRefined ? "toggle--checked" : ""}" ${isRefined ? "checked" : ""}/>
										<span class="toggle-indicator"></span>
										<span class="toggle-label">${window.algoliaLocales.in_stock}</span>
									</label>
									<span class="ais-RefinementList-count inventory-toggle-count">${count}</span>
								</div>
							`;
						}
						
						// Don't render anything for 'Out of Stock'
						return '';
					},
					
				},
			};
		}

		if (facet.escapedName === 'meta.custom.color_group') {
			return {
				...params,
				limit: 1000,
				showMore: false,
				templates: {
					item(item, { html }) {
						const { url, label, count, isRefined } = item;

						// <span class="ais-RefinementList-custom-label">${item.label}</span>
						// 	<span class="ais-RefinementList-count ais-facet--count-distinct">${item.count}</span>

						return html`
							<label 
								class="ais-RefinementList-label ais-facet--label" 
								style="
									${item.label.toLowerCase() == 'multicolored' 
										// rainbow gradient
									? `background-image: linear-gradient(to right, #ff0000, #ffa500, #ffff00, #00ff00, #0000ff, #8b00ff);` 
									: `background-color: ${item.label.toLowerCase()};`}
								
								"
							>
								<input type="checkbox" class="ais-RefinementList-checkbox ais-facet--checkbox ${isRefined ? 'checked' : ''}" ${isRefined ? 'checked' : ''} />
							</label>
						`;
					}
				}
			}
		}
		
		if (facet.type == "disjunctive" || facet.type == "conjunctive") {
			console.log('facet params', ...arguments);

			return {
				...params,
				limit: 12,
				showMoreLimit: 1000,
				showMore: true,
				templates: {
					item(item, { html }) {
						const { url, label, count, isRefined } = item;
				  
						return html`
						<label class="LOOOL ${item.cssClasses.label}">
							${(item.isRefined ? html`
									<input
										type="checkbox"
										class="lol ${item.cssClasses.checkbox}"
										checked
									/>
									` : html`
									<input type="checkbox" class="${item.cssClasses.checkbox}" />
									`)}
									
							${getTranslatedLabel(item.label, facet.escapedName)}
							<span class="${item.cssClasses.count}">
								${item.count}
							</span>
						</label>
						`;
					}
				}
			}
		}

		return {
			...params
		}
	});
	
	console.log('✅ Algolia Search custom hooks registered successfully');
	  
});


/**
 * Updates JSON-LD structured data with current Algolia hits
 * Only runs on collection and search templates
 */
function updateJsonLdStructuredData() {
	// Check if we're on collection or search template
	const isCollectionPage = document.body?.dataset?.template === 'collection' ||
	                        document.body.classList.contains('template-collection');
	const isSearchPage = document.body?.dataset?.template === 'search' ||
	                    document.body.classList.contains('template-search');

	if (!isCollectionPage && !isSearchPage) return;

	// Create or update JSON-LD script
	const jsonLdScriptId = isCollectionPage ? 'algolia-collection-jsonld' : 'algolia-search-jsonld';
	let jsonLdScript = document.getElementById(jsonLdScriptId);

	// Get current hits from the DOM (Algolia product cards)
	const productCards = document.querySelectorAll('.ais-hits-container .ais-product');
	const itemListElement = [];

	productCards.forEach((card, index) => {
		const productUrl = card.querySelector('a')?.href;

		// Get primary image URL from the card
		const primaryImage = card.querySelector('.product-card__image');
		let imageUrl = '';

		if (primaryImage) {
			// Try to get the src, fallback to data-src for lazy loaded images
			imageUrl = primaryImage.src || primaryImage.dataset.src || '';

			// Ensure we have an absolute URL
			if (imageUrl && !imageUrl.startsWith('http')) {
				imageUrl = window.location.origin + imageUrl;
			}
		}

		if (productUrl && imageUrl) {
			itemListElement.push({
				'@type': 'ListItem',
				'position': index + 1,
				'url': productUrl,
				'image': imageUrl
			});
		}
	});

	// Build the complete JSON-LD schema
	const schema = {
		'@context': 'https://schema.org',
		'@type': isCollectionPage ? 'CollectionPage' : 'SearchResultsPage',
		'name': isCollectionPage ?
			(document.querySelector('h1')?.textContent || 'Collection') :
			(window.algoliaLocales?.search_results_for || 'Search Results'),
		'url': window.location.href,
		'mainEntity': {
			'@type': 'ItemList',
			'itemListElement': itemListElement
		}
	};

	// Add collection-specific properties if on collection page
	if (isCollectionPage) {
		const collectionTitle = document.querySelector('h1')?.textContent || 'Collection';
		const collectionDescription = document.querySelector('.collection-description')?.textContent;

		schema.name = collectionTitle;

		if (collectionDescription) {
			schema.description = collectionDescription;
		}

		// Try to get collection image if available
		const collectionImage = document.querySelector('.collection-hero__image img');
		if (collectionImage) {
			let collectionImageUrl = collectionImage.src || collectionImage.dataset.src || '';
			if (collectionImageUrl && !collectionImageUrl.startsWith('http')) {
				collectionImageUrl = window.location.origin + collectionImageUrl;
			}
			if (collectionImageUrl) {
				schema.primaryImageOfPage = {
					'@type': 'ImageObject',
					'url': collectionImageUrl
				};
			}
		}
	}

	// Add search-specific properties if on search page
	if (isSearchPage) {
		const searchQuery = new URLSearchParams(window.location.search).get('q');
		if (searchQuery) {
			schema.query = searchQuery;
		}
	}

	// Create or update the JSON-LD script
	const schemaString = JSON.stringify(schema, null, 2);

	if (jsonLdScript) {
		// Update existing script
		jsonLdScript.textContent = schemaString;
	} else {
		// Create new script
		jsonLdScript = document.createElement('script');
		jsonLdScript.type = 'application/ld+json';
		jsonLdScript.id = jsonLdScriptId;
		jsonLdScript.textContent = schemaString;

		// Insert at the end of head or beginning of body
		const target = document.head || document.body;
		target.appendChild(jsonLdScript);
	}
}

  


let sortBySyncInitialized = false;
document.addEventListener('algolia.instantSearch.onRender', function (e) {

	if (!sortBySyncInitialized) {
		const sortBySelect = document.querySelector('.ais-SortBy-select');

		if (sortBySelect) {
			console.log('⚙️ Algolia Custom Hooks: Initializing sort sync logic.');

			// Get current page context
			let currentContext = null;
			if (document.body.classList.contains('template-search')) {
				currentContext = 'search';
			} else if (document.body.classList.contains('template-collection')) {
				// Extract collection handle from pathname: /en/collections/boy → 'boy'
				const pathParts = window.location.pathname.split('/').filter(Boolean);
				const collectionsIndex = pathParts.indexOf('collections');
				if (collectionsIndex >= 0 && pathParts.length > collectionsIndex + 1) {
					currentContext = pathParts[collectionsIndex + 1];
				}
			}

			if (!currentContext) {
				sortBySyncInitialized = true;
				return;
			}

			const urlParams = new URLSearchParams(window.location.search);
			const sortByParam = urlParams.get('sortBy');

			// Possible sorting suffixes
			const sortingSuffixes = [
				'published_at_desc',
				'published_at_asc',
				'title_asc',
				'title_desc',
				'price_asc',
				'price_desc'
			];

			// Get existing page sorting data
			let pageSortingData = {};
			try {
				pageSortingData = JSON.parse(localStorage.getItem('algoliaPageSorting') || '{}');
			} catch (e) {
				pageSortingData = {};
			}

			const previousContext = localStorage.getItem('algoliaCurrentContext');
			const contextChanged = previousContext !== currentContext;

			// If context changed, remove old sorting data
			if (contextChanged && previousContext) {
				delete pageSortingData[previousContext];
				localStorage.setItem('algoliaPageSorting', JSON.stringify(pageSortingData));
				console.log(`⚙️ Algolia: Context changed from ${previousContext} to ${currentContext}, cleared old sorting`);
			}

			// Update current context
			localStorage.setItem('algoliaCurrentContext', currentContext);

			let appliedSorting = false;

			// Handle sorting logic based on context
			if (!contextChanged) {
				// Same context - try to apply saved or URL sorting
				if (sortByParam) {
					// Check if URL param matches any select option exactly
					const exactMatchOption = sortBySelect.querySelector(`option[value="${sortByParam}"]`);

					if (exactMatchOption) {
						// Valid URL param - use it and save
						const targetIndex = Array.from(sortBySelect.options).indexOf(exactMatchOption);
						sortBySelect.selectedIndex = targetIndex;
						sortBySelect.dispatchEvent(new Event('change'));

						const urlSuffix = sortingSuffixes.find(suffix => sortByParam.endsWith('_' + suffix));
						if (urlSuffix) {
							pageSortingData[currentContext] = urlSuffix;
							localStorage.setItem('algoliaPageSorting', JSON.stringify(pageSortingData));
						}
						console.log(`⚙️ Algolia: Applied exact sorting from URL: ${sortByParam}`);
						appliedSorting = true;
					} else {
						// Invalid URL param - try to find matching option by suffix
						const urlSuffix = sortingSuffixes.find(suffix => sortByParam.endsWith('_' + suffix));
						if (urlSuffix) {
							const suffixMatchOption = sortBySelect.querySelector(`option[value$="${urlSuffix}"]`);
							if (suffixMatchOption) {
								const targetIndex = Array.from(sortBySelect.options).indexOf(suffixMatchOption);
								sortBySelect.selectedIndex = targetIndex;
								sortBySelect.dispatchEvent(new Event('change'));
								pageSortingData[currentContext] = urlSuffix;
								localStorage.setItem('algoliaPageSorting', JSON.stringify(pageSortingData));
								console.log(`⚙️ Algolia: Applied corrected sorting from URL suffix: ${urlSuffix}`);
								appliedSorting = true;
							}
						}
					}
				}

				// If no sorting applied yet and no URL param, try saved sorting
				if (!appliedSorting && !sortByParam) {
					const savedSorting = pageSortingData[currentContext];
					if (savedSorting && sortingSuffixes.includes(savedSorting)) {
						const targetOption = sortBySelect.querySelector(`option[value$="${savedSorting}"]`);
						if (targetOption) {
							const targetIndex = Array.from(sortBySelect.options).indexOf(targetOption);
							sortBySelect.selectedIndex = targetIndex;
							sortBySelect.dispatchEvent(new Event('change'));
							console.log(`⚙️ Algolia: Applied saved sorting for context: ${savedSorting}`);
							appliedSorting = true;
						}
					}
				}
			}

			// Listen for sorting changes to save for current context
			sortBySelect.addEventListener('change', () => {
				const selectedValue = sortBySelect.value;
				if (selectedValue) {
					const selectedSuffix = sortingSuffixes.find(suffix => selectedValue.endsWith('_' + suffix));
					if (selectedSuffix) {
						pageSortingData[currentContext] = selectedSuffix;
						localStorage.setItem('algoliaPageSorting', JSON.stringify(pageSortingData));
						console.log(`⚙️ Algolia: Saved sorting ${selectedSuffix} for context: ${currentContext}`);
					}
				}
			});

			sortBySyncInitialized = true;
		}
	}

	// Setup sticky detection for algolia container
	const algoliaElement = document.getElementById('algolia-shopify-instantsearch');
	if (algoliaElement) {
		function checkStickyState() {
			const rect = algoliaElement.getBoundingClientRect();
			// Add class only when element's top edge is above viewport top
			if (rect.top < 0) {
				algoliaElement.classList.add('sticky-at-top');
			} else {
				algoliaElement.classList.remove('sticky-at-top');
			}
		}

		// Initial check
		checkStickyState();

		// Check on scroll with throttling
		let ticking = false;
		window.addEventListener('scroll', function() {
			if (!ticking) {
				requestAnimationFrame(function() {
					checkStickyState();
					ticking = false;
				});
				ticking = true;
			}
		}, { passive: true });
	}

	// sync collection count with the algolia results count
	const collectionCount = document.querySelector('[data-shopify-results-count]');
	const algoliaResultsCount = document.querySelector('[data-algolia-results-count]');
	if (collectionCount && algoliaResultsCount) {
		collectionCount.textContent = algoliaResultsCount.textContent;
	}

	// update page title on search pages to use algolia results count
	if (document.body.classList.contains('template-search') && algoliaResultsCount) {
		const currentTitle = document.title;
		const algoliaCount = algoliaResultsCount.textContent;

		// Replace any number in the title with the algolia count
		// This handles titles like "Search: 5 results for 'shirt'" -> "Search: 25 results for 'shirt'"
		const updatedTitle = currentTitle.replace(/\d+/, algoliaCount);

		if (updatedTitle !== currentTitle) {
			document.title = updatedTitle;
			console.log('🔍 Updated search page title with Algolia results count:', updatedTitle);
		}
	}

	// === Merge Categories and Subcategories facets (Clone & Re-wire approach) ===
	(function mergeCatsSubs() {
		const categoriesWrapper = document.querySelector('details.ais-facet-meta\\.custom\\.categories_filter');
		const subcatsWrapper = document.querySelector('details.ais-facet-meta\\.custom\\.subcategories_filter');
		if (!categoriesWrapper || !subcatsWrapper) return;
		// Always hide the standalone subcategories facet in the sidebar UI
		if (!subcatsWrapper.classList.contains('is-merged-hidden')) {
			subcatsWrapper.classList.add('is-merged-hidden');
		}
		const originalSubcatsContainer = subcatsWrapper.querySelector('.ais-facet-meta\\.custom\\.subcategories_filter-container .ais-RefinementList');
		if (!originalSubcatsContainer) return;
		const categoriesList = categoriesWrapper.querySelector('.ais-RefinementList');
		if (!categoriesList) return;
		const activeCategoryItem = categoriesList.querySelector('.ais-RefinementList-item--selected');
		
		// Clone and place the subcategory list
		const existingSlot = categoriesList.querySelector('.merged-subcategories-slot');
		if (existingSlot) {
			existingSlot.remove();
		}
		if (activeCategoryItem) {
			// Create a slot to hold the cloned list
			const slot = document.createElement('div');
			slot.className = 'merged-subcategories-slot';
			
			const clonedSubcats = originalSubcatsContainer.cloneNode(true);
			slot.appendChild(clonedSubcats);
			activeCategoryItem.appendChild(slot);
			// Re-wire events from the clone to the original
			const originalInputs = originalSubcatsContainer.querySelectorAll('input[type="checkbox"]');
			const clonedInputs = clonedSubcats.querySelectorAll('input[type="checkbox"]');
			clonedInputs.forEach(clonedInput => {
				clonedInput.addEventListener('click', (e) => {
					e.preventDefault();
					e.stopPropagation();
					// Find the original input that corresponds to this clone and click it
					const originalInput = Array.from(originalInputs).find(input => input.dataset.subcategoryFacetLabel === clonedInput.dataset.subcategoryFacetLabel);
					if (originalInput) {
						originalInput.click();
					}
				});
			});
		}
	})();

	calculateHeaderHeight();

	// Update JSON-LD structured data with current Algolia hits
	updateJsonLdStructuredData();

	// Use the global helper to fetch additional data
	if (window.algoliaProductHelpers) {
		window.algoliaProductHelpers.fetchAdditionalProductData('.ais-hits-container');
	}

	const algoliaProductsRendered = document.querySelector('.ais-hits-container.ais-results-as-block');
	if (algoliaProductsRendered?.children?.length > 0) {
		hidePlaceholder();
	}

	// Set dynamic currency symbol for price facets
	if (window.Shopify && Shopify.currency && Shopify.currency.active) {
		const currencySymbol = Shopify.currency.active === 'USD' ? '$' :
		                      Shopify.currency.active === 'EUR' ? '€' :
		                      Shopify.currency.active === 'GBP' ? '£' :
		                      Shopify.currency.active === 'CAD' ? 'CAD' :
		                      Shopify.currency.active === 'JPY' ? '¥' :
		                      Shopify.currency.active;

		document.documentElement.style.setProperty('--currency-symbol', `'${currencySymbol}'`);
	}

	// rename "Relevance" sorting option to "Best sellers"
	const relevanceOption = document.querySelector('.ais-SortBy-select option:first-child');
	if (relevanceOption && relevanceOption?.textContent == 'Relevance') {
		relevanceOption.textContent = window.algoliaLocales.relevance;
	}
});

// Set up resize listener
const throttledCalculateHeaderHeight = throttle(calculateHeaderHeight, 300);
window.addEventListener('resize', throttledCalculateHeaderHeight);


/**
 * Algolia Loader Script
 * Handles the transition from placeholder to real Algolia content
 */

const algoliaPlaceholder = document.getElementById('algolia-placeholder');
function hidePlaceholder() {
	if (!algoliaPlaceholder) return;
	
	document.body.classList.add('algolia-custom-loaded');
	
	// Remove placeholder from DOM after transition completes
	setTimeout(function() {
		if (algoliaPlaceholder && algoliaPlaceholder.parentNode) {
			algoliaPlaceholder.parentNode.removeChild(algoliaPlaceholder);
		}
	}, 500);
}
		